import * as Yup from 'yup';

export const createUpdateTeamFormConstants = {
  name: { id: 'name', label: 'Name' },
  teamType: { id: 'teamType', label: 'Team Type' },
  industry: { id: 'industry', label: 'End-Use Industry' },
  militaryUse: { id: 'militaryUse', label: 'Military End-Use' },
  dpas: { id: 'dpas', label: 'DPAS Rating' },
  defaultShippingMethod: {
    id: 'defaultShippingMethod',
    label: 'Default Shipping Method',
  },
  defaultCofactrWarehouse: {
    id: 'defaultCofactrWarehouse',
    label: 'Default Cofactr Warehouse',
  },
  defaultShippingDestinationLocation: {
    id: 'defaultShippingDestinationLocation',
    label: 'Default Shipping Destination Location',
  },
};

export const createUpdateTeamValidationSchema = (
  handleReplaceWithCustomTeamName: (inputString: string) => string
) =>
  Yup.object().shape({
    [createUpdateTeamFormConstants.name.id]: Yup.string().required(
      `${createUpdateTeamFormConstants.name.label} is required`
    ),
    [createUpdateTeamFormConstants.teamType.id]: Yup.string().required(
      handleReplaceWithCustomTeamName(
        `${createUpdateTeamFormConstants.teamType.label} is required`
      )
    ),
    [createUpdateTeamFormConstants.industry.id]: Yup.string().nullable(),
    [createUpdateTeamFormConstants.militaryUse.id]: Yup.boolean(),
    [createUpdateTeamFormConstants.dpas.id]: Yup.string().nullable(),
    [createUpdateTeamFormConstants.defaultShippingMethod.id]: Yup.string(),
    [createUpdateTeamFormConstants.defaultCofactrWarehouse.id]:
      Yup.string().nullable(),
    [createUpdateTeamFormConstants.defaultShippingDestinationLocation.id]:
      Yup.string().nullable(),
  });

export const createUpdateTeamTypeFormConstants = {
  name: { id: 'name', label: 'Name' },
  pluralName: { id: 'pluralName', label: 'Plural Name' },
};

export const createUpdateTeamTypeValidationSchema = Yup.object().shape({
  [createUpdateTeamTypeFormConstants.name.id]: Yup.string().required(
    `${createUpdateTeamTypeFormConstants.name.label} is required`
  ),
  [createUpdateTeamTypeFormConstants.pluralName.id]: Yup.string()
    .required(
      `${createUpdateTeamTypeFormConstants.pluralName.label} is required`
    )
    .typeError('Must be a string'),
});
